import {createAction, props} from '@ngrx/store';
import {User} from "@iw-shared/users/models/user";

export const setUser = createAction('[User] set user', props<{ userId: string; }>());
export const setUserFailure = createAction('[User] set user failure');
export const setUserSuccess = createAction('[User] set user success', props<{ user: Omit<User, 'dateCreated' | 'lastUpdate'> }>());
export const resetUser = createAction('[User] reset user ');
